import request from '@/utils/request'
import _ from 'lodash'

const prefix = '/django_rest/personal'

export default {
  getPersonalInfo (params) {
    return request.get(`${prefix}/info/`, { params })
  },
  getMyRewards (params) {
    return request.get(`${prefix}/referral/rewards/`, { params })
  },
  getMyReferralHistory (params) {
    return request.get(`${prefix}/referral/list/`, { params })
  },
  getMyRedeemHistory (params) {
    return request.get(`${prefix}/referral/redeem/`, { params })
  },
  getRedeemPointsResult (params) {
    return request.get(`${prefix}/referral/redeem/points/`, { params })
  },
  redeemPoints (redeemInfo) {
    return request.post(`${prefix}/referral/redeem/points/`, redeemInfo)
  },
  activePersonalEmployee () {
    return request.get('/referral/send-active-employee-email/')
  },
  getMyPotentialCandidate (params) {
    return request.get(`${prefix}/potential-candidate/`, { params })
  },
  updateMyPotentialCandidateAttitude (updateInfo) {
    return request.post(`${prefix}/potential-candidate-attitude/`, updateInfo)
  },
  getMyHiddenPotentialCandidate (params) {
    return request.get(`${prefix}/potential-candidate-hide/`, { params })
  },
  getMyAppliedPotentialCandidate (params) {
    return request.get(`${prefix}/applied-potential-candidate/`, { params })
  },
  getMyDashboardData (params) {
    return request.get(`${prefix}/dashboard/`, { params })
  },
  getMyLeaderBoardData (params) {
    return request.get(`${prefix}/leaderboard/`, { params })
  },
  isResumeFinished (params) {
    return request.get(`${prefix}/resume/is-finished/`, { params })
  },
  getResumeData (params) {
    return request.get(`${prefix}/resume/`, { params })
  },
  createOrUpdateResumeData (resumeData, jobId, companyId) {
    return request.post(`${prefix}/resume/`, resumeData, { params: { job_id: jobId, company_id: companyId } })
  },
  getMiniResumeData (params) {
    return request.get(`${prefix}/mini-resume/`, { params })
  },
  createOrUpdateMiniResumeData (resumeData, jobId, companyId) {
    return request.post(`${prefix}/mini-resume/`, resumeData, { params: { job_id: jobId, company_id: companyId } })
  },
  getBasicResumeData (params) {
    return request.get(`${prefix}/basic-resume/`, { params })
  },
  createOrUpdateBasicResumeData (resumeData, jobId, companyId) {
    return request.post(`${prefix}/basic-resume/`, resumeData, { params: { job_id: jobId, company_id: companyId } })
  },
  uploadCandidatePhoto (photo, jobId, companyId) {
    const formData = new FormData()
    formData.append('photo', photo)
    return request.post(`${prefix}/resume/photo/`, formData, { params: { job_id: jobId, company_id: companyId } })
  },
  checkEmailAndPhone (params) {
    return request.get(`${prefix}/check/email/`, { params })
  },
  getResumeFromThirdParty (params) {
    return request.post('/get-resume-from-thirdparty/', params)
  },
  checkLoginStatusForThirdParty (params) {
    return request.get('/check-login-status-for-thirdparty/', { params })
  },
  uploadResumeFromThirdparty (data) {
    const formData = new FormData()
    _.forEach(data, (value, key) => {
      if (value !== null && key !== undefined) {
        formData.append(key, value)
      }
    })
    return request.post('/upload-resume-from-thirdparty/', formData)
  },
  parseResumeFromThirdParty (params) {
    return request.get('/django_rest/parse-resume-from-thirdparty/', { params })
  },
  getUrlToImportThirdPartyResume (params) {
    return request.get('/django_rest/get-url-to-import-thirdparty-resume/', { params })
  },
  submitResumeToReferral (params) {
    return request.post('/django_rest/referral/submit/resume/', params)
  },
  getForgetPasswordUrlForThirdPartyLogin (params) {
    return request.get('/django_rest/get-forget-password-url-for-thirdparty/', { params })
  },
  getAgreementStatus (params) {
    return request.get(`${prefix}/agreement/`, { params })
  },
  updateAgreement (agreementInfo) {
    return request.post(`${prefix}/agreement/`, agreementInfo)
  },
  getConsentAgreementStatus (params) {
    return request.get(`${prefix}/consent/`, { params })
  },
  updateConsentAgreementStatus (agreementInfo) {
    return request.post(`${prefix}/consent/`, agreementInfo)
  },
  personalUploadResume (fileInfo) {
    const formData = new FormData()
    let onUploadProgress = null
    _.forEach(fileInfo, (value, key) => {
      if (key === 'onUploadProgress') {
        onUploadProgress = value
      } else if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
    return request.post(`${prefix}/upload-resume/`, formData, { onUploadProgress })
  },
  parseCandidateResumeByCandidate (fileInfo) {
    const formData = new FormData()
    let onUploadProgress = null
    _.forEach(fileInfo, (value, key) => {
      if (key === 'onUploadProgress') {
        onUploadProgress = value
      } else if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
    return request.post(`${prefix}/parse-resume-file/`, formData, { onUploadProgress })
  },
  getResumeApplySuccessInfo (jobId, params) {
    return request.get(`${prefix}/finished/apply/${jobId}/`, { params })
  },
  getPersonalApplication (params) {
    return request.get(`${prefix}/application/`, { params })
  },
  getPersonalProfileInfo (params) {
    return request.get(`${prefix}/profile/`, { params })
  },
  updatePersonalCandidateAvatar (jobId, data) {
    return request.post(`${prefix}/candidate-avatar/${jobId}/`, data)
  },
  getPersonalReportInfo (params) {
    return request.get(`${prefix}/report/`, { params })
  },
  personalRevokeApplication (jobId, data) {
    return request.post(`/django_rest/personal/policy/revoke/application/${jobId}/`, data)
  },
  personalRevokeAllApplication (data) {
    return request.post('/django_rest/personal/policy/revoke/all/', data)
  },
  exportPersonalProfilePDF (data) {
    return request.post(`${prefix}/export/profile/`, data)
  },
  getExportPersonalProfilePDFTaskStatus (params) {
    return request.get(`${prefix}/export/profile/`, { params })
  },
  updatePersonalResumeMobile (data) {
    return request.put(`${prefix}/resume/update-mobile/`, data)
  },
  getPersonalAllOfferLetter (params) {
    return request.get(`${prefix}/offer-letter/`, { params })
  },
  getPersonalOfferLetterDetailById (inviteId) {
    return request.get(`${prefix}/offer-letter/${inviteId}/`)
  },
  getJobQuestion (jobId, params) {
    return request.get(`${prefix}/job-questionnaire/${jobId}/`, { params })
  },
  saveJobQuestion (jobId, data) {
    return request.post(`${prefix}/job-questionnaire/${jobId}/`, data)
  },
  getJobInviteQuestion (jobId, params) {
    return request.get(`${prefix}/job-invite-questionnaire/${jobId}/`, { params })
  },
  saveJobInviteQuestion (jobId, data) {
    return request.post(`${prefix}/job-invite-questionnaire/${jobId}/`, data)
  },
  getNextQuestion (params) {
    return request.get(`${prefix}/job-questionnaire/next/`, { params })
  },
  getJobQuestionVideoPaly (params) {
    return request.get(`${prefix}/job-questionnaire-video/`, { params })
  },
  updateJobQuestionVideo (data) {
    return request.post(`${prefix}/job-questionnaire-video/`, data)
  },
  dispatchApply (jobId, params) {
    return request.get(`/apply-job-process/${jobId}/`, { params })
  },
  updatePassword (data) {
    return request.post(`${prefix}/update-password/`, data)
  },
  createParseResumeInfoByCandidateTask (data) {
    return request.post(`${prefix}/parse-resume-file/task/submit/`, data)
  },
  getParseResumeInfoByCandidateTaskStatus (params) {
    return request.get(`${prefix}/parse-resume-file/task/`, { params })
  }
}
